import { CONTRACT, DOCSTORE, EOL } from './../index';
import { Component, OnInit } from '@angular/core';
import { EventManagerService } from 'src/app/core/services/event-manager.service';
import { CONTRACT_ROLES, DOCSTORE_ROLES, RSP_ROLES, ROLE_NAME } from 'src/app/shared/enums/admin-enum';
import { LocalService } from 'src/app/shared/service/local.service';
import { ProfileService } from 'src/app/shared/service/profile.service';
import { AUTHORIZED, MENU_PORTAL, SRM } from '..';
import { Spinner } from './../../../../core/services/spinner.service';

@Component({
  selector: 'app-layout-header-mobile',
  templateUrl: './layout-header-mobile.component.html',
  styleUrls: ['./layout-header-mobile.component.scss']
})
export class LayoutHeaderMobileComponent implements OnInit {
  userName;
  selectedItem;
  isShowSelectedItem = false;
  isShowSidebarMobile = true;
  isSupplierHasPermission = false;
  hasDestructionPermission = false;
  hasRecyclingPermission = false;
  isSRM = false;
  isContract = false;
  isDocStore = false;
  isEOL = false;
  menuPortal = MENU_PORTAL;
  menuSRM = SRM;
  menuContract = CONTRACT;
  menuDocStore = DOCSTORE;
  eolMenu = EOL;
  roles = [];
  roleName = '';

  constructor(
    private eventManager: EventManagerService,
    private service: LocalService,
    private spinner: Spinner,
    private profileService: ProfileService
   ) { }

  ngOnInit() {
    this.roles = atob(localStorage.getItem(btoa('role'))).split(',');
    this.roleName = this.roles.map(role => ROLE_NAME[role]).toString();
    this.spinner.show();
    this.profileService.getProfileUser().subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.data.roles.findIndex(i => i === 'GUEST') === -1) {
        this.userName = res.data.fullName;
        this.isSRM = res.data.authorized.some(i => i === AUTHORIZED.SRM) ? true : false;
        this.isContract = res.data.authorized.some(i => i === AUTHORIZED.CONTRACT)  ? true : false;
        this.isDocStore = res.data.authorized.some(i => i === AUTHORIZED.DOCSTORE)  ? true : false;
        this.isEOL = res.data.roles.some(i => i === RSP_ROLES.SUPER_USER || i === RSP_ROLES.EOL_ADMIN);
        const isSupplier = Array.isArray(res?.data?.roles)
          && res.data.roles.some((i: any) => i === RSP_ROLES.SUPPLIER);
        const eolInfos = res?.data?.eolInfos && res?.data?.eolInfos.length && res?.data?.eolInfos.length > 0 
          ? res.data.eolInfos : [];
        const supplierForm = eolInfos && eolInfos.length && eolInfos.length > 0 ? eolInfos[0]?.supplierForm : null;
        this.hasDestructionPermission = !!(supplierForm && supplierForm.destruction === true);
        this.hasRecyclingPermission = !!(supplierForm && supplierForm.recycling === true);
        this.isSupplierHasPermission = !!(isSupplier && (this.hasDestructionPermission || this.hasRecyclingPermission));
        const primaryRole = res.data.primaryRole === 'CONTRACT' ? this.roles.filter(r => CONTRACT_ROLES[r])[0]
        : this.roles.filter(r => RSP_ROLES[r])[0];
        this.roleName = ROLE_NAME[primaryRole];
      }
    });
  }

  mobileSidebarShow() {
    this.isShowSidebarMobile = !this.isShowSidebarMobile;
    this.eventManager.broadcast({
      name: 'SHOW_SIDEBAR',
      data: {
        isShow: this.isShowSidebarMobile
      }
    });
  }

  onClick(item): void {
    this.selectedItem = item;
    this.isShowSelectedItem = !this.isShowSelectedItem;
  }

  logOut() {
    localStorage.removeItem(btoa('userName'));
    localStorage.removeItem(btoa('role'));
    window.location.href = '/logout';
  }

  contactUs() {
    const btnContactUs = document.getElementById('contact-us');
    const btnOpens = document.getElementsByClassName('bc-minimize-state-idle') as HTMLCollectionOf<HTMLElement>;
    const btnOpen = btnOpens[0];

    if (btnOpen) {
      btnOpen.click();
    } else {
      if (btnContactUs) {
        btnContactUs.click();
      }
    }
  }

  // goPageWiki() {
  //   this.service.getUrlWiki().subscribe((res) => {
  //     window.open(res.data.length ? res.data[0].url : res.data.url);
  //   });
  // }

  redirectTo(item) {
    return '/login?redirectTo=' + item;
  }

  public checkHidden(permissions: any[], item?: any) {
    if (item && item.url) {
      if (item.url.indexOf('/eol/destruction') !== -1 && !this.hasDestructionPermission && !this.isEOL) {
        return true;
      }
      if (item.url.indexOf('/eol/recycling') !== -1 && !this.hasRecyclingPermission && !this.isEOL) {
        return true;
      }
    }
    let hidden = true;
    permissions.forEach(item => {
      if (this.roles.findIndex(k => k === item) !== -1) {
        hidden = false;
      }
    });
    return hidden;
  }
}
